import { newError, ERR_INVALID_STATE } from "../../utils/error";
import { loadContentAsBlobUrl } from "../../utils/dom";
import { joinPath } from "../../utils/string";
let gSpriteUrl = null;
export function getSpriteUrl() {
    if (gSpriteUrl == null) {
        throw newError(ERR_INVALID_STATE, "gSpriteUrl == null");
    }
    return (gSpriteUrl !== null && gSpriteUrl !== void 0 ? gSpriteUrl : "");
}
export async function prepareSprites(pDataPath) {
    if (gSpriteUrl == null) {
        const tSpritePath = joinPath(pDataPath, "cf/images/oap_sprite_v6.svg");
        gSpriteUrl = await loadContentAsBlobUrl(tSpritePath);
    }
}
